import React from 'react'
function Slider() {
  return (
    <>
   <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active ">
      <div className='get'>
      <p className='fs-5'>Get up to 50% off Today Only!</p>
      <h1 className='fashion py-2'>Woman Fashion</h1>
      <button type="button" class="btn btn-danger danger">SHOP NOW</button>
      </div>
      <img src={require('../images/banner1.jpg')} className="d-block w-100" alt="..." />
    </div>
    <div className="carousel-item position-relative">
    <div className='get'>
      <p className='fs-5'>50% off in all products</p>
      <h1 className='fashion py-2'>Man Fashion</h1>
      <button type="button" class="btn btn-danger danger">SHOP NOW</button>
      </div>
      <img src={require('../images/banner2.jpg')} className="d-block w-100" alt="..." />
    </div>
    <div className="carousel-item position-relative">
    <div className='get'>
      <p className='fs-5'>Taking your Viewing Experience to Next Level</p>
      <h1 className='fashion py-2'>Summer Sale</h1>
      <button type="button" class="btn btn-danger danger">SHOP NOW</button>
      </div>
      <img src={require('../images/banner3.jpg')} className="d-block w-100" alt="..." />
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true" />
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true" />
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </>
  )
}

export default Slider
